import React from 'react'
import { Form } from './form'
import { Link } from 'react-router-dom'
import { X } from 'react-feather'

const Content = ({required}) => {
  return (
    <div className="w-full lg:w-6/12 mx-auto h-screen flex items-center">
      <div className="w-full bg-white lg:rounded h-full lg:h-auto py-24 md:py-20 relative">
        <Link to="/" className="absolute top-0 right-0 p-5">
          <X />
        </Link>
        <div className="flex items-center flex-wrap -mx-4">
          <div className="w-full md:w-2/3 mx-auto px-4">
            {
              required &&
              <div className="w-full mb-5 text-center">
                <p className="text-gray-444 text-sm text-center mx-auto">To .... .... .... .... , please sign in.</p>
              </div>
            }
            <h1 className="text-3xl lg:text-4xl text-center font-accent mb-5 lg:mb-10 uppercase">
              Sign In
            </h1>
            <Form className="mb-5 lg:mb-8"/>
            <p className="text-center text-gray-444 text-sm">Don't have an account? <Link to="/register" className="text-secondary link underline">Sign up now</Link></p>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Content }
